<script lang="ts">
    import { onDestroy } from "svelte"

    export let sessionStart: Date

    let timeString: string

    const updateTimeString = () => {
        const now = new Date()
        const diffMs = now.getTime() - new Date(sessionStart).getTime()
        const diffMinutes = Math.floor(diffMs / 60000)
        const diffSeconds = Math.floor((diffMs % 60000) / 1000)

        timeString = `${diffMinutes}:${diffSeconds < 10 ? "0" : ""}${diffSeconds} Min`
    }

    // Update time every second
    const interval = setInterval(updateTimeString, 1000)

    // Initial update
    updateTimeString()

    // Cleanup interval on component destruction
    onDestroy(() => {
        clearInterval(interval)
    })
</script>

<div class="time-display">
    {timeString}
</div>

<style>
    .time-display {
        font-size: 0.7rem;
        color: white;
    }
</style>
